import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Avatar from '../avatar';
import WireCaption from '../../../wire/wire-caption';
import WireTitle from '../wire-title';

const Container = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: ${props => (props.theme.isMobile ? '16px 0px' : '16px 0px')};
  border-bottom: 1px dashed ${props => props.theme.primaryColor};
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 8;
  margin-left: 16px;
`;

const CaptionRow = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 10px;
  line-height: 18px;
  text-transform: uppercase;

  & > span.separator {
    font-size: 16px;
    font-weight: ${props => props.theme.fontWeightBolder};
  }
`;

const Name = styled.a`
  &, & > span {
    color: ${props => props.theme.secondaryColor};
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightHeavy};
    text-transform: uppercase;
    font-size: 14px;
    line-height: 15px;
  }

  &&&:hover {
    color: ${props => props.theme.secondaryColor};
    transition: none;
  }
`;

const Org = styled.span`
  color: ${props => props.theme.secondaryColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 12px;
  line-height: 12px;
`;

export default function MicroWire({ wire }) {
  return (
    <Container>
      <Avatar profile={wire.profile} size="sm" />
      <Details>
        <CaptionRow>
          <WireCaption wire={wire} />
        </CaptionRow>
        <WireTitle wire={wire} showEditorManageTools={false} twoLinesTruncated />
        <Name href={`/contributors/${wire.profile.slug}`}>{wire.profile.name}</Name>
        <Org>{wire.profile.organisation}</Org>
      </Details>
    </Container>
  );
}

MicroWire.propTypes = {
  wire: PropTypes.shape().isRequired,
};
